import script from "./dashboardAccessDenied.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboardAccessDenied.vue?vue&type=script&setup=true&lang=js"

import "./dashboardAccessDenied.vue?vue&type=style&index=0&id=93fc6aca&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93fc6aca"]])

export default __exports__